import isMobile from 'ismobilejs';
import { useState, useEffect } from 'react';

export function useDeviceType() {
  const [device, setDevice] = useState<'mobile' | 'tablet' | 'desktop' | null>(
    null,
  );
  useEffect(() => {
    const { phone: isPhone, tablet: isTablet } = isMobile(window.navigator);
    setDevice(isPhone ? 'mobile' : isTablet ? 'tablet' : 'desktop');
  }, []);

  return device;
}
